import { render, staticRenderFns } from "./PageFooter.vue?vue&type=template&id=3cce2477&scoped=true&"
import script from "./PageFooter.vue?vue&type=script&lang=js&"
export * from "./PageFooter.vue?vue&type=script&lang=js&"
import style0 from "./page-footer.scss?vue&type=style&index=0&id=3cce2477&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cce2477",
  null
  
)

export default component.exports